let configData = {
    defaultOprPkId: "0127",
    languageShow: false,
    loginUrl: null,
    ajaxHost: "/api/serv",
    apiStatus: 0,
    host: "",
    footText: "珠海兴诺能源技术有限公司 粤ICP备19041187号 © Copyright",
    footTextEnglish: "Zhuhai Xingnuo Energy Technology Co., Ltd. Guangdong ICP No. 19041187 © Copyright",
    formSize: "small",
    appThemeClass: "",
    pickerOptions: {
        // 今天以后都不能选
        disabledDate(time) {
            return time.getTime() > new Date().setHours(0, 0, 0, 0);
        },
    },
    pickerOptionsTomorrow: {
        // 今天以后都不能选（包含今天）
        disabledDate(time) {
            return time.getTime() > new Date().setHours(0, 0, 0, 0) - 1;
        },
    },
    pickerOptionsPreMonth: {
        // 往前一个月开始到后面都不能选
        disabledDate(time) {
            return (time.getTime() >
                new Date().setHours(0, 0, 0, 0) - 60 * 60 * 24 * 30 * 1000);
        },
    },
    pickerOptionsMin: {
        // 今天以前都不能选
        disabledDate(time) {
            return time.getTime() < new Date().setHours(0, 0, 0, 0);
        },
    },
    pickerOptionsMin2: {
        // 今天以前都不能选,包括今天
        disabledDate(time) {
            return time.getTime() < new Date().setHours(0, 0, 0, 0) + 1;
        },
    },
    draggable: false,
    // mapKeyApi: "20982f19b8adfb01fb694d153e0af294",
    mapKeyApi: "38963cf6e1d7092a3dfcf940b4979bd5",
    echartsJS: "./echarts.min.js",
    fileImg: "/api/file/",
    sysModulePkId: "1",
    footerUrl: "https://beian.miit.gov.cn",
    powerObj: {
        // 权限对应的code,在页面里面直接用 xx.query 来做按钮权限,权限直接加入到 $route.meat 里面的 privilegeVoList
        "100501": "query",
        "100502": "add",
        "100503": "updata",
        "100504": "delete",
        "100505": "logout",
        "100506": "audit",
        "100507": "handle",
        "100508": "export",
        "100509": "endOrder",
        "100510": "grant",
        "100511": "stop",
        "100512": "relevance",
        "100513": "cancelRelevance",
        "100514": "recharge",
        "100515": "refund",
        "100516": "blacklist",
        "100517": "openCar",
        "100518": "import",
        "100519": "give",
        "100520": "invalid",
        "100521": "site",
        "100522": "line",
        "100523": "entMember",
        "100524": "userGroup",
        "100525": "bind",
        "100526": "set",
        "100527": "adjust",
        "100528": "homeData",
        "100529": "orderlyCharging",
    },
    isHomeData: false,
    otherPageAuto: {
        // 菜单以外有入口的页面权限,如果菜单没有,那入口也要去掉
        "/alarm-event": "alarmEvent",
        "/oper-manage/message/system-notice": "systemNotice",
        "/operators/oper-info": "operInfo",
        "/oper-manage/message/platform-notice": "platformNotice",
    },
    autoUrl: {},
    tableStripe: false,
    position: {
        lat: 22.546054,
        lng: 114.025974,
        city: "",
    },
    orderDetailsEcharts: true,
    // destroyedCard86: true, // 86专用注销卡
    socketServer: "ws://127.0.0.1:8784/Pilot",
    downloadUrl: "http://files.qn.smartpevc.com/%E6%B4%BE%E8%AF%BA%E5%8F%91%E5%8D%A1%E6%8F%92%E4%BB%B620191209.exe",
    downloadUrl32: "http://files.qn.smartpevc.com/USB%E8%BD%ACRS232_WIN.zip",
    downloadUrlXP32: "http://files.qn.smartpevc.com/USB%E8%BD%ACRS232_XP.zip",
    downLoadNet35: "http://download.microsoft.com/download/2/0/E/20E90413-712F-438C-988E-FDAA79A8AC3D/dotnetfx35.exe",
    onLineMax: null,
    offLineMax: null,
    UEDITOR_HOME_URL: "/ueditor/",
    modalWidth: 720,
    modalWidthSmall: 540,
    tableName: {
        // 表格名称的配置
        minWidth: 184,
        tooltip: true,
    },
    tablePrice: {
        // 表格价格的配置
        align: "right",
    },
};
//为了防止哪天在域名中间加了东西 或者接口域名变了 ，然后外面连接一个js 文件 js 文件里放这几个参数就可以了
// 其它打包路径已设置为相对路径 ,只和 static  和 index.html 文件 在同一层级就可以了
const win = window;
if (win.appConfig && typeof win.appConfig == "object") {
    configData = Object.assign(configData, win.appConfig);
}
export default configData;
